import React, { useState, useEffect, useCallback } from 'react';
import moment from 'moment';
import { useHistory, Redirect } from 'react-router-dom';

import Loading from '~/components/layout/Loading';
import api from "~/services/api";
import ApiBullets from "~/services/Bulletins/api";
import { formatCNPJ } from '~/utils/utils';
import { useSelector, useDispatch } from 'react-redux';
import SideBar from '~/components/layout/Sidebar';
import BackPage from '~/components/layout/BackPage';
// import BackPage from '~/components/layout/BackPageWhite';

import ChallengesContainer from './styles';
import OpenChatBot from '~/components/layout/Chatbot';

const SegmentedComunicationDetails = () => {
  const dispatch = useDispatch();
  const classificationReducer = useSelector(
    state => state.classificationReducer,
  );
  const notificationReducer = useSelector(
    state => state.notificationReducer,
  );

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const id = params.get('id');

  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [image, setImage] = useState(null)
  const [notification, setNotification] = useState(null);

  const header = {
    'Content-Type': 'application/json',
    access_token: localStorage.getItem('access_token'),
  };
  const parameters = {
    headers: header,
  };

  useEffect(() => {
    if (notificationReducer.notifications.length > 0) {
      const notification = notificationReducer.notifications.find((item) => item.id === parseInt(id));
      if (notification.cover) {
        setImage(notification.cover);
      }
      if (notification) {
        setNotification(notification)
      }
    }
  }, []);

  useEffect(() => {
    fetchTracking();
  }, []);

  async function fetchTracking() {
    let document = localStorage.getItem('storeDocument');
    if (document && document != 'undefined'){
      document = formatCNPJ(document);
    }

    try {
      await api
      .put(
        '/customer-relationship/sitel/v1/reads',
        {
          bulletinsid: id,
          cnpj: document
        },
        parameters
      )
      .then(res => {
      })
      .catch(err => {
        console.log("Error tracking read - details.", err);
      });
    } catch (error) {
      console.warn("Exceção in read - details.", error);
      return false
    }
  }

  return (
    <>
      <ChallengesContainer>
        <SideBar menuSelected={''}>
          {/* <HeaderLapidar noMarginBottom={true} /> */}
          <ChallengesContainer.Container
            storeInfo={classificationReducer.storeClassification}
          >
            <ChallengesContainer.Content>
              <ChallengesContainer.NavigationContainer>
                {/* <ChallengesContainer.Top>
                  <BackPage page="/segmented-comunication" />
                </ChallengesContainer.Top> */}
                <ChallengesContainer.TopWhite>
                  <BackPage page="/segmented-comunication" />
                </ChallengesContainer.TopWhite>
                {loading && <Loading />}
                {!loading && (
                  <>
                    {/* <ChallengesContainer.SectionChallenges>
                      <ChallengesContainer.AreaImageTitle>
                        <ChallengesContainer.AreaImage>
                          {image && (
                            <img src={image} alt="Imagem de notificação" style={{ width: '100%' }} />
                          )}
                        </ChallengesContainer.AreaImage>
                        <ChallengesContainer.AreaText>
                        {notification && (
                          <>
                            <ChallengesContainer.AreaTitle>
                              {notification.title}
                            </ChallengesContainer.AreaTitle>
                            <ChallengesContainer.AreaSub>
                              {notification.caption}
                            </ChallengesContainer.AreaSub>
                          </>
                        )}
                        </ChallengesContainer.AreaText>
                      </ChallengesContainer.AreaImageTitle>
                    </ChallengesContainer.SectionChallenges> */}
                    <ChallengesContainer.AreaHtml>
                      <ChallengesContainer.AreaContent>
                        {notification && (
                          <div
                            dangerouslySetInnerHTML={{__html: notification.content}}
                          />
                        )}
                      </ChallengesContainer.AreaContent>
                    </ChallengesContainer.AreaHtml>
                  </>
                )}
              </ChallengesContainer.NavigationContainer>
            </ChallengesContainer.Content>
          </ChallengesContainer.Container>
          <OpenChatBot />
        </SideBar>
      </ChallengesContainer>
    </>
  );
};

export default SegmentedComunicationDetails;
